<ng-container *ngIf="ready">
    <app-notification></app-notification>

    <header>
        <div class="container-fluid p-0">

            <nav class="navbar navbar-toggleable-sm navbar-fixed-top scrollbar-primary-nav-bar">
                <a class="navbar-brand">
                    <img src="assets/img/new_logo.png" class="logo d-inline mt-2 logo-web" />
                    <div class="d-flex justify-content-center mt-3 mb-3 d-md-none">
                        <div class="hello-user-navbar">
                            <span>
                                Hola <br> {{ companyName | sliceName }}
                            </span>
                        </div>
                    </div>
                </a>
                <a class="navbar-toggler click navbar-icon mb-3" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <mat-icon class="vertical-align-middle">menu</mat-icon>
                </a>
                <div class="collapse navbar-collapse nav-var-top-top-end-custom" id="navbarNav">
                    <div class="d-flex me-3 mt-3 mt-lg-0 ">
                        <div class="hello-user-navbar d-none d-md-block">
                            <span>
                                Hola <br> {{ companyName | sliceName }}
                            </span>
                        </div>
                    </div>

                    <ul class="navbar-nav">
                        <li class="nav-item me-2 mb-1">
                            <mat-form-field appearance="outline" class="nav-bar-mat-form-field">
                                <mat-label class="fc-black">Actividad</mat-label>
                                <mat-select #t1 (selectionChange)="changeActivity(t1.value)"
                                    [(value)]="activitySelected" class="ms-2" name="activitySelected">
                                    <mat-option *ngFor="let item of activity; trackBy: trackByIndex" [value]="item.uid">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </li>
                        <li class="nav-item me-2 mb-1">
                            <mat-form-field appearance="outline" class="nav-bar-mat-form-field">
                                <mat-label class="fc-black">Año Fiscal</mat-label>
                                <mat-select #t2 (selectionChange)="changeYear(t2.value)" [(value)]="yearSelected"
                                    class="ms-2" name="yearSelected">
                                    <mat-option *ngFor="let year of years; trackBy: trackByIndex" [value]="year">
                                        {{ year }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </li>
                    </ul>

                    <button class="navbar-icon" matTooltip="Escanear código QR" mat-icon-button routerLink="/qrcode"
                        (click)="moveToContent($event, endMenu)">
                        <mat-icon class="vertical-align-middle">center_focus_weak</mat-icon>
                    </button>

                    <!--  <button class="navbar-icon" matTooltip="Ficheros" mat-icon-button routerLink="/files"
                      (click)="moveToContent($event, endMenu)">
                        <mat-icon class="vertical-align-middle">folder</mat-icon>
                    </button> -->

                    <button class="navbar-icon" matTooltip="Contactos" mat-icon-button routerLink="/contact"
                        (click)="moveToContent($event, endMenu)">
                        <mat-icon class="vertical-align-middle">account_box</mat-icon>
                    </button>

                    <button class="navbar-icon" mat-icon-button matTooltip="Notificaciones" routerLink="/notification"
                        (click)="moveToContent($event, endMenu)">
                        <mat-icon>notifications</mat-icon>
                        <span class="badge" *ngIf="getNotificationCount > 0">{{ getNotificationCount }}</span>
                    </button>

                    <!-- <button mat-icon-button
                        [ngClass]="showHelp == true ? 'navbar-icon-Active click' : 'navbar-icon click'"
                        (click)="toggleHelp()" matTooltip="Activar/Desactivar ayuda">
                        <mat-icon class="vertical-align-middle">help</mat-icon>
                    </button> -->

                    <button mat-icon-button
                        [ngClass]="showHelp == true ? 'navbar-icon-Active click' : 'navbar-icon click'"
                        [matMenuTriggerFor]="afterMenu" matTooltip="Ayuda">
                        <mat-icon class="vertical-align-middle">help</mat-icon>
                    </button>

                    <mat-menu #afterMenu="matMenu" xPosition="after">
                        <ng-container *ngIf="showHelp">
                            <button mat-menu-item class="navbar-icon-Active click" (click)="toggleHelp()">
                                <mat-icon class="vertical-align-middle">help</mat-icon>
                                Desactivar ayuda
                            </button>
                        </ng-container>
                        <ng-container *ngIf="!showHelp">
                            <button mat-menu-item class="click" (click)="toggleHelp()">
                                <mat-icon class="vertical-align-middle">help</mat-icon>
                                Activar ayuda
                            </button>
                        </ng-container>
                        <button mat-menu-item class="click" routerLink="/help">
                            <mat-icon class="vertical-align-middle">help</mat-icon>
                            Cuentas
                        </button>
                    </mat-menu>

                    <button mat-icon-button class="navbar-icon" [matMenuTriggerFor]="menu" matTooltip="Ajustes">
                        <mat-icon click="toggleSidevar">account_circle</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                        <button mat-menu-item [matMenuTriggerFor]="menuActivity" class="d-block d-md-none">
                            <mat-icon>assignment</mat-icon>
                            <span>Actividad</span>
                        </button>

                        <mat-menu #menuActivity="matMenu">
                            <ng-container *ngFor="let item of activity; let i = index; trackBy: trackByIndex">
                                <ng-container *ngIf="item.uid === activitySelected">
                                    <button mat-menu-item (click)="changeActivity(item.uid)">
                                        <strong>{{ item.name }}</strong>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="item.uid !== activitySelected">
                                    <button mat-menu-item (click)="changeActivity(item.uid)">
                                        {{ item.name }}
                                    </button>
                                </ng-container>
                            </ng-container>
                        </mat-menu>

                        <button mat-menu-item [matMenuTriggerFor]="menuYear" class="d-block d-md-none">
                            <mat-icon>date_range</mat-icon>
                            <span>Año fiscal</span>
                        </button>

                        <mat-menu #menuYear="matMenu">
                            <ng-container *ngFor="let year of years; trackBy: trackByIndex">
                                <ng-container *ngIf="year === yearSelected">
                                    <button mat-menu-item (click)="changeYear(year)">
                                        <strong>{{ year }}</strong>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="year !== yearSelected">
                                    <button mat-menu-item (click)="changeYear(year)">
                                        {{ year }}
                                    </button>
                                </ng-container>
                            </ng-container>
                        </mat-menu>

                        <div [ngClass]="showHelp == true ? 'fc-orange click d-block d-md-none ms-3' : 'fc-black click d-block d-md-none ms-3'"
                            (click)="toggleHelp()">
                            <mat-icon class="vertical-align-middle">help</mat-icon>
                            <span class="ms-3 me-1">Activar</span>
                        </div>

                        <ng-container *ngIf="user.isAdmin">
                            <button mat-menu-item routerLink="/admin/users">
                                <mat-icon>build</mat-icon>
                                <span>Admin</span>
                            </button>
                        </ng-container>

                        <ng-container *ngIf="user.isConsultant && user.isConsultant">
                            <button mat-menu-item routerLink="/consultant/">
                                <mat-icon>work</mat-icon>
                                <span>Asesoría</span>
                            </button>
                        </ng-container>

                        <ng-container *ngIf="user.isConsultant">
                            <button mat-menu-item routerLink="/consultant/">
                                <mat-icon>work</mat-icon>
                                <span>Grupo empresarial</span>
                            </button>
                        </ng-container>

                        <button mat-menu-item routerLink="/account/contact">
                            <mat-icon>person</mat-icon>
                            <span>Mi Cuenta</span>
                        </button>
                        <button mat-menu-item routerLink="/subscription">
                            <mat-icon>subscriptions</mat-icon>
                            <span>Suscripción</span>
                        </button>

                        <button mat-menu-item (click)="disableEnableFirstSteps()">
                            <mat-icon>school</mat-icon>
                            <span>{{ isEnableFirstSteps == true ? 'Desactivar' : 'Activar' }} mis "Primeros
                                pasos"</span>
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <mat-icon>power_settings_new</mat-icon>
                            <span>Salir</span>
                        </button>

                        <ng-container
                            *ngIf="consultantBusinessGroupInfo.status && consultantBusinessGroupInfo.isConsultant">
                            <button mat-menu-item (click)="backToConsulting()">
                                <mat-icon>work</mat-icon>
                                <span>Volver a asesoría</span>
                            </button>
                        </ng-container>
                        <ng-container
                            *ngIf="consultantBusinessGroupInfo.status && consultantBusinessGroupInfo.isBusinessGroup">
                            <button mat-menu-item (click)="backToConsulting()">
                                <mat-icon>work</mat-icon>
                                <span>Volver a grupo empresarial</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                </div>
            </nav>

            <nav class="navbar navbar-toggleable-sm navbar-fixed-top scrollbar-primary">
                <div class="collapse navbar-collapse" id="navbarNav">
                    <mat-nav-list class="navbarOption" *ngFor="let module of modules; trackBy: trackByIndex" routerLinkActive="active">
                        <a [routerLink]="[module.onClick]" (click)="moveToContent($event, endMenu)"
                            *ngIf="(module.onClick === '/subscription' || (module.modelIncluded))">
                            <span class="ms-1">{{ module.modelName }}</span>
                        </a>
                        <a *ngIf="(module.onClick !== '/subscription' && (module.modelIncluded == false))"
                            class="nav-link disabled">
                            <span class="ms-1 notAllow">{{ module.modelName }}</span>
                        </a>
                    </mat-nav-list>
                </div>
            </nav>
        </div>
        <app-size-detector></app-size-detector>
        <div #endMenu></div>
    </header>
</ng-container>

<ng-container *ngIf="!ready">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>